export default "__VITE_ASSET__BKiOW4AA__"